import { render, staticRenderFns } from "./hot-coupon.vue?vue&type=template&id=49698340&scoped=true&"
import script from "./hot-coupon.vue?vue&type=script&lang=js&"
export * from "./hot-coupon.vue?vue&type=script&lang=js&"
import style0 from "./hot-coupon.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./hot-coupon.vue?vue&type=style&index=1&id=49698340&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "49698340",
  null
  
)

export default component.exports